module.exports = __webpack_public_path__ + "static/media/tourist_arrival_ph_bumpchart_worldwide_wide.07fdf89b.png";